import { render } from "./ShippingPriceModal.vue?vue&type=template&id=626b8fcd"
import script from "./ShippingPriceModal.vue?vue&type=script&lang=js"
export * from "./ShippingPriceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__